import React from "react";
import Slider from "react-slick";
import { Box, Typography, Avatar, Paper } from "@mui/material";
import airdrop from "../../../assets/newairdrop.png";
import invite from "../../../assets/newinvite.png";
// import cryptoshare from "../../assets/newccryptoshare.png";

// Sample testimonials data
// const testimonials = [
// 	{
// 		name: "futures event",
// 		title: "Share 50,000 USDT",
// 		image: airdrop,
// 		subQuote: "Futures Hot Crypto Challenge ",

// 		quote: "BUZZ | ALPHA | WCT",
// 	},
// 	{
// 		name: "Initial Futures Listing",
// 		title: "collat",
// 		image: invite,
// 		subQuote: "Trade Collat Futures and win a share of ",

// 		quote: "50,000 USDT",
// 	},
// 	{
// 		name: "Share $160,400 Daily",
// 		title: "BTC Pizza Day",
// 		image: invite,
// 		subQuote: "Double M-Day",

// 		quote: "double your M-Day rewards",
// 	},
// ];

const testimonials = [
	{
		name: "Bitcoin Halving Event",
		title: "Bitcoin Price Surge",
		image: airdrop, // replace with your actual image import or URL
		subQuote: "Historical Halving Impact",
		quote: "Bitcoin's price has historically surged post-halving!",
	},
	{
		name: "DeFi Yield Farming",
		title: "Earn Passive Income",
		image: invite, // replace with your actual image import or URL
		subQuote: "Maximize your crypto yields",
		quote: "Stake your tokens and earn up to 20% APY!",
	},
	{
		name: "NFT Marketplace Boom",
		title: "Collect & Trade",
		image: airdrop, // replace with your actual image import or URL
		subQuote: "Unique digital assets",
		quote: "NFT sales hit $2 billion in the last quarter!",
	},
	{
		name: "Ethereum 2.0 Staking",
		title: "Secure & Earn",
		image: airdrop, // replace with your actual image import or URL
		subQuote: "Stake ETH and earn rewards",
		quote: "Stake 32 ETH to become a validator and earn staking rewards.",
	},
	{
		name: "Crypto Adoption Growth",
		title: "Mass Adoption",
		image: airdrop, // replace with your actual image import or URL
		subQuote: "Mainstream acceptance",
		quote: "Over 100 million users now own some form of cryptocurrency.",
	},
];

// Carousel settings
const settings = {
	dots: true,
	infinite: true,
	speed: 600,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 3000,
	pauseOnHover: true,
	arrows: false,
	fade: true,
};

const UpdateCarousel = () => {
	return (
		<Box
			sx={{
				maxWidth: {
					xs: "100%", // small screens
					sm: 600, // small to medium screens
					md: 800, // medium screens
					lg: "40%", // large screens
				},
				minHeight: "3rem",
				mx: "auto",
				mt: 4,
				px: 1,
				borderRadius: 2,
			}}>
			{/* <Typography variant="h5" align="center" gutterBottom sx={{ mb: 3 }}>
                What Our Users Say
            </Typography> */}
			<Slider {...settings}>
				{testimonials.map((testimonial, index) => (
					<Box
						key={index}
						sx={{ px: 2, display: "flex", justifyContent: "center" }}>
						<Paper
							elevation={3}
							sx={{
								p: 2,
								maxWidth: "37rem",
								m: "auto",
								color: "white",
								textAlign: "center",
								bgcolor: "green",
								// border: "1px solid lightgray",
								borderRadius: 2,
								display: "flex",
								flexDirection: "row-reverse",
								alignItems: "center",
								justifyContent: "center",
								background: "linear-gradient(to right, black, black, darkblue)", // Gradient from black to blue
							}}>
							{/* <Avatar
                                src={testimonial.image}
                                alt={testimonial.name}
                                sx={{ width: "100%", height: "100%", mx: "auto", mb: 2 }}
                            /> */}
							{/* <img src={} alt="" /> */}
							<div
								style={{
									backgroundImage: `url(${testimonial.image})`,
									width: "9rem",
									height: "12rem",
									borderRadius: "50%",
									backgroundSize: "cover",
									backgroundPosition: "center",
									content: "",
								}}></div>
							<Box sx={{ textAlign: "left", textTransform: "uppercase" }}>
								<Typography variant="h6" gutterBottom>
									<span className="inline-block  min-w-fit text-[0.9rem]  px-[1rem]  py-[0.1rem]  rounded-full bg-gradient-to-r  from-blue-200 to-red-300 font-bold text-black    ">
										{testimonial.name}
									</span>
								</Typography>
								{/* <Typography
                                    variant="subtitle2"
                                    color="textSecondary"
                                    gutterBottom>
                                    {testimonial.title}
                                </Typography> */}
								<Typography
									sx={{
										fontSize: "1.6rem",
										mt: 2,
										fontWeight: "bold",
										color: "white",
									}}>
									{testimonial.title}
								</Typography>
								<Typography
									variant="body1"
									sx={{
										fontSize: "0.8rem",
										mt: 2,
										letterSpacing: "0.1rem",
										color: "lightgray",
										textTransform: "capitalize",
									}}>
									{testimonial.subQuote}
								</Typography>
								<Typography variant="body1" sx={{ color: "white", mt: 1 }}>
									{testimonial.quote}
								</Typography>
							</Box>
						</Paper>
					</Box>
				))}
			</Slider>
		</Box>
	);
};

export default UpdateCarousel;
